// extracted by mini-css-extract-plugin
export default {"popupContainer":"pop-up_popupContainer__hfw7W","popupWrapper":"pop-up_popupWrapper__UK4j6"};